import Heading from "./Heading";

export { Heading };
